import React from "react";
import { Route, Switch } from "react-router-dom";

import Reports from "../../../modules/Employees/Reports";

export default () => {
  return (
    <Switch>
      <Route exact path="/employees/reports" component={Reports} />
    </Switch>
  );
};